const storagePrefix = 'app-tickets';

function getData(key, defaultValue) {
    const prefixedKey = `${storagePrefix}:${key}`;
    const value = window.localStorage.getItem(prefixedKey);

    if (value) {
        return JSON.parse(value);
    }

    return defaultValue;
}

function removeData(key) {
    const prefixedKey = `${storagePrefix}:${key}`;
    window.localStorage.removeItem(prefixedKey);
}

function setData(key, value) {
    const prefixedKey = `${storagePrefix}:${key}`;
    try {
        return window.localStorage.setItem(prefixedKey, JSON.stringify(value));
    } catch (error) {
        const otherError = !(error instanceof DOMException || error.message.indexOf('QuotaExceededError'));
        if (otherError) {
            throw error;
        }
    }

    return undefined;
}

function dispatchStorageEvent(key, value) {
    const prefixedKey = `${storagePrefix}:${key}`;
    const oldValue = getData(key);
    const newValue = JSON.stringify(value);

    const event = new StorageEvent('storage', {
        key: prefixedKey,
        oldValue,
        newValue,
    });
    window.dispatchEvent(event);
}

function hasData(key) {
    const prefixedKey = `${storagePrefix}:${key}`;
    return window.localStorage.hasOwnProperty(prefixedKey);
}

export default {
    getData,
    setData,
    hasData,
    removeData,
    dispatchStorageEvent,
}
